export const environment = {
    production: false,
    i18nVersion: '2026.10.02',
    authUrl: 'https://dev-auth.psycocenter.com',
    clientId: 'psycocenter-ui',
    clientSecret: 'simplified',
    redirectUri: 'https://dev.psycocenter.com/callback',
    postLogoutRedirectUri: 'https://dev.psycocenter.com',
    apiUrl: 'https://dev-api.psycocenter.com',
    tenantId: 'PsycoCenter',
    scope: 'openid person:read person:write role:read role:write permission:read permission:write scope:read scope:write client:read client:write patients commitments module:movements configs expense:write reports'
};
